<template>
  <div>
    <div class="message" v-for="(message,index) in messages" :class="{own: message.userId == userId}" :key="index">
      <div class="date" v-if="index>0 && messageDate(messages[index-1]) != messageDate(message)">
        {{ messageDate(message) }}
      </div>
      <div class="date" v-if="index == 0">
        {{ messageDate(message) }}
      </div>
      <div class="username" v-if="index>0 && messages[index-1].userId != message.userId">
        {{ message.userId }}
      </div>
      <div class="username" v-if="index == 0">
        {{ message.userId }}
      </div>
      <div style="margin-top: 5px" />
      <div>
        <div class="content">
          <div v-html="messageText(message)" />
          <chat-image v-if="message.type === 'photo'" :imgsrc="message.data.url" @imageLoad="imageLoad" />
        </div>
        <span class="time">
          {{ messageTime(message) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import Image from './Image.vue'

  export default {
    data () {
      return {}
    },
    props: {
      index: String,
    },
    components: {
      'chat-image': Image
    },
    computed: {
      userId () {
        return this.$store.getters.user.userId
      },
      chat () {
        return this.$store.getters.chats[this.index] || {}
      },
      messages () {
        return this.$store.getters.messages(this.chat.chatId)
      }
    },
    methods: {
      imageLoad () {
        // this.$emit('imageLoad')
      },
      messageDate(message) {
        return new Date(message.created).toISOString().substring(0,10)
      },
      messageTime(message) {
        return new Date(message.created).toISOString().substring(11,19)
      },
      messageText(message)  {
        var urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
        if (message.type === 'text') {
          const text = message.data.text
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;')
            .replace(urlPattern, "<a href='$1'>$1</a>")
          return text
        } else if (message.type === 'file') {
          const url = `https://xn--22-9kcqjffxnf3b.xn--p1ai/api/v1/chat/files/${message.data.fileId}/${message.data.name}`
          return `<a href="${url}">${message.data.name}</a>`
        }
      }
    }
  }
</script>

<style>
  span.emoji {
    font-size: 20px;
    vertical-align: middle;
    line-height: 2;
  }
</style>
